import { render, staticRenderFns } from "./ColorsLabel.vue?vue&type=template&id=063dc8d5"
import script from "./ColorsLabel.vue?vue&type=script&lang=js"
export * from "./ColorsLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports